
<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Commission Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Commission Config</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <a href="javascript:void(0)" class="btn btn-info" @click="showFilter = !showFilter"><i class="fa fa-filter"></i>Filter</a>
            <div class="card-tools">
              <router-link v-if="actionCreate == true" :to="{ name: 'CommissionConfigAdd'}" class="btn btn-success">
                <i class="fas fa-plus"></i> New
              </router-link>
            </div>
          </div>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body p-0">
            <form @submit.prevent="getList()" method="GET" novalidate>
              <div class="card-body" v-if="showFilter">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group row">
                      <label class="col-2 col-form-label" for="name">Name</label>
                      <div class="col-9">
                        <input type="text" id="name" class="form-control" v-model="filter.name" placeholder="Name">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-10 offset-1">
                    <button type="submit" class="btn btn-primary m-2px">Search</button>
                    <button type="reset" class="btn btn-warning" @click="resetFilter()">Reset</button>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="card-body table-responsive-md p-0">
            <table class="table table-responsive">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Commission Plan</th>
                  <th>Status</th>
                  <th>Activation Startdate</th>
                  <th>Activation Enddate</th>
                  <th>Priority</th>
                  <th>Commission type</th>
                  <th>Commission</th>
                  <th>Max commission amount</th>
                  <th>Applicable Period</th>
                  <th>Previous Tier Id</th>
                  <th>Match all conditions</th>
                  <th>Disbursement date configuration</th>
                  <th>Next disbursement date</th>
                  <th>Split type</th>
                  <th>App-Id</th>
                  <th>Migrate after</th>
                  <th class="text-right">Action</th>
                </tr>
              </thead>
              <tbody class="list">
                <tr v-for="(val, index) in list.data" :key="val.id">
                  <td>{{ val.id }}</td>
                  <td>{{ val.name }}</td>
                  <td>{{ val.description }}</td>
                  <td>{{ val.commission_plan_id }}</td>
                  <td>{{ val.status }}</td>
                  <td>{{ val.activation_start }}</td>
                  <td>{{ val.activation_end }}</td>
                  <td>{{ val.priority }}</td>
                  <td>{{ val.commission_type }}</td>
                  <td>{{ val.commission }}</td>
                  <td>{{ val.max_commission_amount }}</td>
                  <td>{{ val.applicable_period }}</td>
                  <td>{{ val.prev_tier_id }}</td>
                  <td>{{ val.follow_all_conds }}</td>
                  <td>{{ val.disb_date_conf }}</td>
                  <td>{{ val.next_disbursement_date }}</td>
                  <td>{{ val.split_type }}</td>
                  <td>{{ val.app_id }}</td>
                  <td>{{ val.migrate_after }}</td>
                  <td class="text-right">
                    <router-link v-if="actionView == true" :to="{ name: 'CommissionConfigShow', params: { id: val.id }}" class="btn btn-info btn-sm m-2px">
                      <i class="fas fa-eye"></i>
                    </router-link>
                    <router-link v-if="actionEdit == true" :to="{ name: 'CommissionConfigEdit', params: { id: val.id }}" class="btn btn-info btn-sm m-2px">
                      <i class="fas fa-pencil-alt"></i>
                    </router-link>
                    <a v-if="actionDelete == true" class="btn btn-danger btn-sm m-2px" href="javascript:void(0)" @click="deleteObject(val.id, index)"><i class="fas fa-trash"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="p-4" v-if="_.isEmpty(list.data) && is_loading == false">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination :pagination="list" v-if="list.total > list.per_page" @paginate="getList()"></vue-pagination>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import VuePagination from '@/components/partials/PaginationComponent';
import { CBSCommissionApi } from '@/services/api';

export default {
  name: 'CommissionConfig',
  components: {
    VuePagination
  },
  data: () => ({
    list: {
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1
    },
    actionCreate: true,
    actionView: true,
    actionEdit: true,
    actionDelete: false,
    showFilter: false,
    filter: {},
    pre: [],
    is_loading: false,
    empty: false,
    empty_message: ''
  }),
  mounted: function () {
    this.getList();
  },
  methods: {
    getList: function () {
      this.is_loading = true
      CBSCommissionApi.getCommissionConfig(this.list.current_page, this.filter, this.list.per_page)
        .then((items) => {
          this.list = items
        })
        .finally(() => {
          this.is_loading = false
        });
    },
    resetFilter () {
      this.list.current_page = 1
      this.filter = {}
      this.getList()
    }
  }
}
</script>
